export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_5738821d-4a05-4d66-8921-ea504c8be611/artifacts/8grn0zko_image.png";

export const HERO_SLIDES = [
  {
    image:
      "https://customer-assets-jt897jd0.emergentagent.net/job_avado-distribution/artifacts/40z99sg3_f38a7b50-c2d8-4a88-af95-4cdac0c30c95.jpeg",
    kicker: "Global Distribution • Since 2014",
    title: "Delivering the brands the world trusts.",
    subtitle:
      "USA. Caribbean. Africa. Europe. — a direct-source export partner for beverages, health & beauty and general merchandise.",
  },
  {
    image:
      "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?auto=format&fit=crop&w=1920&q=80",
    kicker: "Wholesale Export • Bulk Formats",
    title: "Move faster. Sell smarter. Grow with Avado.",
    subtitle:
      "From skincare essentials to shelf-favourite beverages — we source and ship at wholesale prices with white-glove logistics.",
  },
  {
    image:
      "https://images.unsplash.com/photo-1613690399151-65ea69478674?auto=format&fit=crop&w=1920&q=80",
    kicker: "100+ Active Exports",
    title: "Your shelves. Fully stocked.",
    subtitle:
      "A curated portfolio of 50+ globally recognised brands — ready to ship, priced to compete, backed by decade-long expertise.",
  },
];

export const BRAND_LOGOS = [
  { name: "Unilever", url: "/logos/unilever.png" },
  { name: "Nivea", url: "/logos/nivea.jpg" },
  { name: "Jergens", url: "/logos/jergens.png" },
  { name: "Vaseline", url: "/logos/vaseline.jpg" },
  { name: "Schwarzkopf", url: "/logos/schwarzkopf.png" },
  { name: "Revlon", url: "/logos/revlon.png" },
  { name: "Cantu", url: "/logos/cantu.jpg" },
  { name: "7UP", url: "/logos/7up.png" },
  { name: "Wesson", url: "/logos/wesson.png" },
  { name: "Nutella", url: "/logos/nutella.png" },
  { name: "Pringles", url: "/logos/pringles.jpg" },
  { name: "Dove", url: "/logos/dove.gif" },
  { name: "Gillette", url: "/logos/gillette.png" },
  { name: "Right Guard", url: "/logos/right-guard.png" },
  { name: "Arm & Hammer", url: "/logos/arm-hammer.png" },
  { name: "Suave", url: "/logos/suave.png" },
  { name: "Degree", url: "/logos/degree.png" },
  { name: "Procter & Gamble", url: "/logos/pg.png" },
  { name: "Fanta", url: "/logos/fanta.png" },
  { name: "Colgate-Palmolive", url: "/logos/colgate.png" },
  { name: "Snapple", url: "/logos/snapple.png" },
  { name: "Schweppes", url: "/logos/schweppes.jpeg" },
  { name: "Mountain Dew", url: "/logos/mountain-dew.png" },
  { name: "Tropicana", url: "/logos/tropicana.png" },
  { name: "Gatorade", url: "/logos/gatorade.jpg" },
  { name: "Sprite", url: "/logos/sprite.jpg" },
  { name: "Coca-Cola", url: "/logos/coca-cola.jpg" },
  { name: "Badia Spices", url: "/logos/badia.png" },
];

export const CATEGORIES = [
  {
    name: "Snacks and Confectionery",
    slug: "snacks-confectionery",
    count: "40+ brands",
    image: "https://customer-assets-jt897jd0.emergentagent.net/job_avado-distribution/artifacts/dpidwsx3_food.jpeg",
  },
  {
    name: "Appliances",
    slug: "appliances",
    count: "20+ brands",
    image: "https://customer-assets-jt897jd0.emergentagent.net/job_avado-distribution/artifacts/h758at52_appliances.png",
  },
  {
    name: "Spirits",
    slug: "spirits",
    count: "30+ brands",
    image: "https://customer-assets-jt897jd0.emergentagent.net/job_avado-distribution/artifacts/hp8zxto2_alcohol.jpeg",
  },
  {
    name: "Beer and Hard Seltzers",
    slug: "beer-hard-seltzers",
    count: "25+ brands",
    image: "https://customer-assets-jt897jd0.emergentagent.net/job_avado-distribution/artifacts/i2kahfbq_beers.jpeg",
  },
  {
    name: "Beverages",
    slug: "beverages",
    count: "60+ brands",
    image: "https://customer-assets-jt897jd0.emergentagent.net/job_avado-distribution/artifacts/cr4s72jk_beverages.jpeg",
  },
  {
    name: "Haircare",
    slug: "haircare",
    count: "35+ brands",
    image: "https://customer-assets-jt897jd0.emergentagent.net/job_avado-distribution/artifacts/0nnv62t2_haircare.jpeg",
  },
  {
    name: "Beauty and Wellbeing",
    slug: "beauty-wellbeing",
    count: "50+ brands",
    image: "https://customer-assets-jt897jd0.emergentagent.net/job_avado-distribution/artifacts/zczpi0ml_skincare.jpeg",
  },
  {
    name: "Home Essentials",
    slug: "home-essentials",
    count: "30+ brands",
    image: "https://customer-assets-jt897jd0.emergentagent.net/job_avado-distribution/artifacts/t6wna9dc_household.jpeg",
  },
  {
    name: "Petfood",
    slug: "petfood",
    count: "15+ brands",
    image: "https://customer-assets-jt897jd0.emergentagent.net/job_avado-distribution/artifacts/6ecx138k_ddf4859d-ae00-4ab0-9f57-4c1deef9bffc.jpeg",
  },
];

export const SERVICES = [
  {
    num: "01",
    title: "Food & Beverages Provider",
    desc: "A wide variety of food and beverage products engineered for distribution — drinks, food, spices, tableware and more, ready for communities and large-format retailers.",
  },
  {
    num: "02",
    title: "Custom Product Sourcing",
    desc: "We analyse your business, then curate a tailored portfolio of products adapted to your customer base — premium quality at exceptional wholesale pricing.",
  },
  {
    num: "03",
    title: "New Product Development",
    desc: "We help you detect supply and demand gaps in your community, identify emerging products and refresh your shelf to avoid stagnancy.",
  },
  {
    num: "04",
    title: "New Product Trends",
    desc: "We follow the trends. Our team continuously tracks emerging FMCG categories, viral brands and shifting consumer tastes so your shelves stay ahead of what shoppers ask for next.",
  },
];

export const HOW_WE_WORK = [
  {
    step: "01",
    title: "Discussion",
    desc: "Contact us and share the products or categories you're looking to distribute.",
  },
  {
    step: "02",
    title: "Strategize",
    desc: "We analyse the market, source directly and send you the best affordable pricing.",
  },
  {
    step: "03",
    title: "Deliver & Export",
    desc: "You open an account, we load your order and ship it to your destination — worldwide.",
  },
];

export const STATS = [
  { value: "10+", label: "Years in business" },
  { value: "25+", label: "Specialists on staff" },
  { value: "100+", label: "Active exports" },
  { value: "50+", label: "Top brands stocked" },
];

export const TESTIMONIALS = [
  {
    name: "John Richmond",
    role: "Executive Director",
    company: "HiLo Supermarket",
    quote:
      "Amazing customer service. Avado has been our go-to distribution partner for three years running — I'd recommend them to anyone.",
    avatar: "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=400&q=80",
  },
  {
    name: "Alexander Brown",
    role: "Marketing Director",
    company: "KFC (Regional)",
    quote:
      "Fast and reliable services. Their logistics team is unmatched — pallets land on schedule, invoices are clean, communication is proactive.",
    avatar: "https://images.unsplash.com/photo-1652471943570-f3590a4e52ed?auto=format&fit=crop&w=400&q=80",
  },
  {
    name: "Marisa Delacruz",
    role: "Head of Procurement",
    company: "Island Grocers Group",
    quote:
      "Avado unlocked pricing tiers we couldn't touch before. Their strategic sourcing has grown our margins by nearly 18% year-over-year.",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=400&q=80",
  },
];

export const CONTACT = {
  address: "8510 N.W. 72nd Street, Miami, FL 33166",
  hours: "Monday–Friday 8:00am – 4:00pm",
  email: "sales@avadoglobaltrading.com",
  emailInfo: "info@avadoglobaltrading.com",
  office: "305-602-8191",
  fax: "973-333-3548",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Brands", href: "#brands" },
  { label: "Categories", href: "#categories" },
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Contact", href: "#contact" },
];
